import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const expensesConstants = {
    EXPENSE_LOADED: 'EXPENSE_LOADED',
    EXPENSE_CREATED: 'EXPENSE_CREATED',
    EXPENSE_UPDATED: 'EXPENSE_UPDATED',
    EXPENSE_DELETE: 'EXPENSE_DELETE',
};

export const expenseFulfilledConstants = getActionTypesResult(expensesConstants, '_FULFILLED');
export const expensePendingConstants = getActionTypesResult(expensesConstants, '_PENDING');
export const expenseRejectedConstants = getActionTypesResult(expensesConstants, '_REJECTED');

export const getFilterExpense = createAsyncAction(expensesConstants.EXPENSE_LOADED, () =>
    api.get('expenseManagement/reportFilter').then(res => res.data)
);

export const saveExpenseFilter = createAsyncAction(expensesConstants.EXPENSE_CREATED, data =>
    api.post('expenseManagement/reportFilter', data).then(res => res.data)
);

export const updateExpenseFilter = createAsyncAction(expensesConstants.EXPENSE_UPDATED, data =>
    api.put('expenseManagement/reportFilter', data).then(res => res.data)
);

export const resetExpenseFilter = createAsyncAction(expensesConstants.EXPENSE_DELETE, () =>
    api.delete('expenseManagement/reportFilter').then(res => res.data)
);
